import { IPermissions } from "container/management/user/rolesAndPermission/permission.interface";
import { ISelectOptionNonGroup } from "../interface/types";

export const Status = {
  CREATED: 201,
  SUCCESS: 200,
  NOTACCEPTABLEEXCEPTION: 406
};
export const UPLOADING_STATUS = {
  UPLOADING: "uploading",
  DONE: "done",
  REMOVED: "removed",
  ERROR: "error"
};

export const DateTimeFormat = "dd-MM-yyyy '|' HH:mm:ss";

export const DateFormat = "dd-MM-yyyy";

export const DateMonthYearFormat = "MMMM, yyyy";

export const ServiceFacilityEnum = {
  HOSPITALS: "hospitals",
  HOSPITALS_GROUP: "hospitals-group",
  LABS: "labs",
  DISCOUNT_CENTERS: "discount-centers",
  DISCOUNT_CENTERS_GROUP: "discount-centers-group",
  CASH_LESS_WORKSHOPS: "cash-less-workshops",
  CASH_LESS_WORKSHOPS_GROUP: "cash-less-workshops-group"
};
export const ListOfValues = {
  PACRA: "pacraRating",
  RELATION: "relation",
  SUPPORTEDFORMAT: "supportedFormat",
  PLANTYPE: "planType",
  Region: "region"
};
export const FILE_FORMATS = {
  PDF: "application/pdf",
  JPG: "image/jpg",
  JPEG: "image/jpeg",
  PNG: "image/png",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
};

export const statusDropdown: ISelectOptionNonGroup[] = [
  { value: "", label: "all" },
  { value: "true", label: "active" },
  { value: "false", label: "in_active" }
];

export const PLAN_TYPE_KEYS = {
  SELF: "self",
  FAMILY: "family",
  PARENT: "parents",
  SPOUSE: "spouse",
  CHILD: "child"
};

export const PRICE_TYPE_KEYS = {
  INDIVIDUAL: "individual",
  AGGREGATED: "aggregated"
};

export const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  PRODUCTION: "production"
};

export const ACTIVITY_LOG_OPERATIONS = {
  I: "Added",
  U: "Changed",
  D: "Removed"
};

export const CoverageTypes = {
  MAXLIIMIT: "maxLimit",
  MAXDAYS: "maxDays",
  PERCENTAGE: "percentage",
  ENTITLEMENT: "entitlement",
  COVERED: "covered"
};

export const NUMERIC_TYPES = {
  PERCENTAGE: "%",
  RUPEES: "Rs",
  USD: "USD"
};

export const YearOptions: ISelectOptionNonGroup[] = [
  { label: "2010", value: 2010 },
  { label: "2011", value: 2011 },
  { label: "2012", value: 2012 },
  { label: "2013", value: 2013 },
  { label: "2014", value: 2014 },
  { label: "2015", value: 2015 },
  { label: "2016", value: 2016 },
  { label: "2017", value: 2017 },
  { label: "2018", value: 2018 },
  { label: "2019", value: 2019 },
  { label: "2020", value: 2020 },
  { label: "2021", value: 2021 },
  { label: "2022", value: 2022 },
  { label: "2023", value: 2023 },
  { label: "2024", value: 2024 },
  { label: "2025", value: 2025 },
  { label: "2026", value: 2026 },
  { label: "2027", value: 2027 },
  { label: "2028", value: 2028 },
  { label: "2029", value: 2029 },
  { label: "2030", value: 2030 },
  { label: "2031", value: 2031 },
  { label: "2032", value: 2032 },
  { label: "2033", value: 2033 },
  { label: "2034", value: 2034 },
  { label: "2035", value: 2035 },
  { label: "2036", value: 2036 },
  { label: "2037", value: 2037 },
  { label: "2038", value: 2038 },
  { label: "2039", value: 2039 },
  { label: "2040", value: 2040 },
  { label: "2041", value: 2041 },
  { label: "2042", value: 2042 },
  { label: "2043", value: 2043 },
  { label: "2044", value: 2044 },
  { label: "2045", value: 2045 },
  { label: "2046", value: 2046 },
  { label: "2047", value: 2047 },
  { label: "2048", value: 2048 },
  { label: "2049", value: 2049 },
  { label: "2050", value: 2050 }
];

export const LINE_OF_BUSINESS = {
  AUTO: 1,
  Travel: 2,
  HEALTH: 3,
  LIFE: 10,
  PERSONALACCIDENT: 5,
  HOUSEHOLD: 7
};

export const LINE_OF_BUSINESS_VALUES = {
  AUTO: "Auto",
  Travel: "Travel",
  HEALTH: "Health",
  LIFE: "Life",
  FAMILY: "Family"
};

export const LINE_OF_BUSINESS_ENUM = {
  AUTO: "auto",
  HEALTH: "health",
  FAMILY: "family"
};
export const SURVEY_TYPE = {
  DIGITAL: "digital",
  MANUAL: "manual"
};

export const AUTO_ENUM = {
  AUTO: "auto"
};

export const HEALTH_ENUM = {
  HEALTH: "health"
};
export const TRAVEL_ENUM = {
  TRAVEL: "travel"
};

export const PERSONAL_ACCIDENT_ENUM = {
  personalAccident: "personalAccident"
};

export const HOUSE_HOLD_ENUM = {
  houseHold: "houseHold"
};
export const LIFE_ENUM = {
  life: "life"
};

export const AGE_DURATION_TYPES = {
  YEAR: "Y",
  DAY: "D"
};

export const DURATION_TYPES = {
  YEAR: "Y",
  DAY: "D",
  MONTH: "M"
};
export const RATE_TYPE: { [key: string]: string } = {
  ANNUAL: "Annual",
  MONTHLY: "Monthly"
};
export const DefaultPermissions: IPermissions = {
  create: false,
  update: false,
  view: false,
  delete: false
};

export const SALE_POINTS: { [key: string]: string } = {
  CALL_CENTER: "Call Center",
  DIGITAL: "Digital"
};
export const GovermentOfficialOptions: ISelectOptionNonGroup[] = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
];
export const CONTRIBUTION_MODES = {
  AGE_RESTRICTION: "Age Restrictions",
  FIXED_PRICE: "Fixed Price"
};

export const DEBOUNCE_DELAY_IN_MS = 500;

export const SALE_CATEGORIES = {
  B2C: "B2C",
  B2B: "B2B"
};

export const RequestStatuses = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected"
};

export const MINIMUM_ALLOWED_VALUE = 0;
export const MINIMUM_ALLOWED_VALUE_IN_DAYS = 1;
export const NUMBER_OF_DAYS_IN_YEARS = 365;
export const NUMBER_OF_MONTHS_IN_YEAR = 12;
